<template>
  <v-form v-model="dataIsValid">
    <v-row>
      <v-col cols="4">
        <div class="address-title">
          <div class="mb-3 body-1 font-weight-medium">Адрес регистрации заявителя</div>
        </div>
        <address-form
          addressType="802740000"
          :income="registrationsAddress"
          @transferData="setRegistrationsAddress"
          :address="formData.addresses ? formData.addresses[0] : null"
        ></address-form>
      </v-col>

      <v-col cols="4">
        <div class="address-title">
          <div class="mb-3 body-1 font-weight-medium">Адрес проживания заявителя</div>
          <v-checkbox v-model="isEqualRegAddress" label="Совпадает с адресом регистрации"></v-checkbox>
        </div>
        <address-form
          addressType="802740003"
          :disabled="isEqualRegAddress"
          :income="residenceAddress"
          @transferData="setResidenceAddress"
          :address="formData.addresses ? formData.addresses[1] : null"
        ></address-form>
      </v-col>

      <v-col cols="4">
        <div class="address-title">
          <div class="mb-3 body-1 font-weight-medium">Адрес доставки квитанции</div>
          <v-checkbox v-model="isEqualResAddress" label="Совпадает с адресом проживания"></v-checkbox>
        </div>
        <address-form
          addressType="802740001"
          :disabled="isEqualResAddress"
          :income="deliveryAddress"
          @transferData="setDeliveryAddress"
          :address="formData.addresses ? formData.addresses[2] : null"
        ></address-form>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>

  import AddressForm from "../components/partial/AddressForm";

  export default {
    props: ["income", 'formData'],
    components: {
      AddressForm
    },
    data: () => ({
      // DATA
      isEqualResAddress: false,
      isEqualRegAddress: false,
      registrationsAddress: null,
      deliveryAddress: null,
      residenceAddress: null,
      dataIsValid:false
    }),
    methods: {
      transferData() {
        this.$emit("transfer", {
          isEqualResAddress: this.isEqualResAddress,
          isEqualRegAddress: this.isEqualRegAddress,
          registrationsAddress: this.registrationsAddress,
          deliveryAddress: this.deliveryAddress,
          residenceAddress: this.residenceAddress
        });
      },
      setRegistrationsAddress(payload) {
        this.registrationsAddress = payload;
      },
      setDeliveryAddress(payload) {
        this.deliveryAddress = payload;
      },
      setResidenceAddress(payload) {
        this.residenceAddress = payload;
      }

    },
    created() {
      let keys = Object.keys(this.income);
      keys.forEach(key => {
        this[key] = this.income[key];
      });
    },
    watch: {
      isEqualRegAddress: {
        immediate: true,
        handler: function (value) {
          if (value) {
            this.residenceAddress = {
              ...this.registrationsAddress,
              addressType: "802740003"
            };
          }
        }
      },
      isEqualResAddress: {
        immediate: true,
        handler: function (value) {
          if (value) {
            this.deliveryAddress = {
              ...this.residenceAddress,
              addressType: "802740001"
            };
          }
        }
      },
      dataIsValid: {
        immediate: true,
        handler: function (value) {
          this.$emit("lockFwdBtn", !value);
        }
      },
      registrationsAddress: {
        immediate: true,
        handler: function (value) {
          if (this.isEqualRegAddress) {
            this.residenceAddress = {
              ...value,
              addressType: "802740003"
            };
          }
        }
      },
      residenceAddress: {
        immediate: true,
        handler: function (value) {
          if (this.isEqualResAddress) {
            this.deliveryAddress = {
              ...value,
              addressType:"802740001"
            };
          }
        }
      }
    }
  };
</script>

<style scoped>
  .address-title {
    height: 100px;
  }
</style>
